import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { Metadata } from 'next'
import ServicePageTemplate, { ServicePageConfig } from '@/components/templates/ServicePageTemplate'

export const metadata: Metadata = {
  title: 'Personal Travel Planner | Member Services | FGA Prestige',
  description: 'Bespoke travel experiences crafted to perfection. Curated itineraries and bookings for stress-free, personalized luxury travel.',
  openGraph: {
    title: 'Personal Travel Planner | Member Services | FGA Prestige',
    description: 'Bespoke travel experiences crafted to perfection. Curated itineraries and bookings for stress-free, personalized luxury travel.',
    url: 'https://fgaprestige.com/member-services/personal-travel-planner',
    images: [
      {
        url: '/Member Services/Personal Travel Planner/hero.png',
        width: 1200,
        height: 630,
        alt: 'FGA Prestige Personal Travel Planner',
      },
    ],
  },
}

const personalTravelConfig: ServicePageConfig = {
  title: 'Personal Travel Planner - FGA Prestige',
  description: 'Bespoke travel experiences crafted to perfection.',
  slug: 'personal-travel-planner',
  heroImage: '/Member Services/Personal Travel Planner/hero.png',
  serviceName: 'PERSONAL TRAVEL PLANNER',
  whySectionA: {
    title: 'Crafted Journeys Bespoke Travel Services by FGA Prestige',
    content: 'Step into a world where each journey is as unique as you are—where tailored itineraries, private guides, and seamless logistics transform travel into an art form. Imagine exploring vibrant destinations, from hidden city enclaves to remote island escapes, with every detail thoughtfully curated for you. Luxury accommodations, exclusive experiences, and privileged access await at every turn, ensuring that discovery is effortless and adventure feels personal.',
    image: '/Member Services/Personal Travel Planner/body/1.png',
    imageAlt: 'Exclusive Travel Experiences'
  },
  whySectionC: {
    title: 'Your Travel Concierge. At Your Side, Everywhere',
    content: 'Meet your travel concierge: a master of anticipation, blending expert planning with insider knowledge to open doors few ever see. From last-minute reservations at coveted restaurants to private tours after hours, every wish is orchestrated quietly and elegantly—so you can simply savour the moment, wherever you are in the world.',
    image: '/Member Services/Personal Travel Planner/body/2.png',
    imageAlt: 'Exclusive Travel Experiences'
  },
  whySectionB: {
    title: 'Journeys Without Limits. Let Curiosity Lead the Way',
    benefits: [
      {
        title: '',
        description: 'Whether planning a whirlwind shopping escape in Paris or a tranquil retreat in Kyoto, your curated travel service elevates every moment. Unburdened by logistics, you move smoothly from one experience to the next, collecting memories with the ease that comes only from true expertise. Your only worry? Deciding where in the world to go next.'
      }
    ],
    image: '/Member Services/Personal Travel Planner/body/3.png',
    imageAlt: 'Luxury Travel Planning Services'
  },
  masterpieceBackgroundImage: '/Member Services/Personal Travel Planner/CTA Banner/banner.png'
}

export default function PersonalTravelPlannerPage() {
  return (
    <>
      <Helmet>
        <title>Personal Travel Planner | Member Services | FGA Prestige</title>
        <meta name="description" content="Bespoke travel experiences crafted to perfection. Curated itineraries and bookings for stress-free, personalized luxury travel." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/personal-travel-planner" />
        <meta property="og:title" content="Personal Travel Planner | Member Services | FGA Prestige" />
        <meta property="og:description" content="Bespoke travel experiences crafted to perfection. Curated itineraries and bookings for stress-free, personalized luxury travel." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/personal-travel-planner" />
        <meta property="og:image" content="/Member Services/Personal Travel Planner/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Personal Travel Planner" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Personal Travel Planner | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Bespoke travel experiences crafted to perfection. Curated itineraries and bookings for stress-free, personalized luxury travel." />
        <meta name="twitter:image" content="/Member Services/Personal Travel Planner/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Personal Travel Planner",
            "description": "Bespoke travel experiences crafted to perfection. Curated itineraries and bookings for stress-free, personalized luxury travel.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/personal-travel-planner",
            "image": "/Member Services/Personal Travel Planner/hero.png"
          })}
        </script>
      </Helmet>
      <ServicePageTemplate config={personalTravelConfig} />
    </>
  )
}